import { useState } from 'react';
import ScrollReveal from '@/components/common/ScrollReveal';
import { stories } from '@/mocks/landing';

const AVATAR = ['from-[#2f6bff] to-[#7b5cff]', 'from-[#ff4d8d] to-[#ff8a5c]', 'from-[#00c2a8] to-[#00a0e9]'];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const count = stories.length;
  // The featured story first, then the others in order.
  const ordered = stories.map((_, i) => stories[(active + i) % count]!);
  const [main, ...rest] = ordered;

  return (
    <section id="customers" className="w-full bg-white pb-16 md:pb-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <h2 className="text-2xl md:text-[34px] md:leading-tight font-bold text-[#1f2329] tracking-tight">
            Chosen by teams
            <br />
            that grow with loyalty
          </h2>
          <div className="flex gap-2">
            {[-1, 1].map((d) => (
              <button
                key={d}
                type="button"
                aria-label={d < 0 ? 'Previous story' : 'Next story'}
                onClick={() => setActive((a) => (a + d + count) % count)}
                className="w-9 h-9 rounded-full border border-[#dee0e3] flex items-center justify-center text-[#1f2329] hover:border-[#2f51d6] hover:text-[#2f51d6] cursor-pointer transition-colors"
              >
                <i className={d < 0 ? 'ri-arrow-left-line' : 'ri-arrow-right-line'} />
              </button>
            ))}
          </div>
        </div>

        {main && (
          <div className="grid grid-cols-1 md:grid-cols-[1.9fr_1fr_1fr] gap-4">
            <ScrollReveal key={main.company} animation="fade-in" className="rounded-2xl bg-gradient-to-br from-[#e3eaff] to-[#f5f7ff] p-6 md:p-7 flex flex-col">
              <div className="flex items-center gap-3">
                <span className={`w-12 h-12 rounded-full bg-gradient-to-br ${AVATAR[active % 3]} text-white font-bold flex items-center justify-center`}>
                  {main.name.charAt(0)}
                </span>
                <div>
                  <div className="font-heading font-bold text-[#1f2329]">{main.company}</div>
                  <div className="text-xs text-[#646a73]">
                    {main.name}, {main.role}
                  </div>
                </div>
              </div>
              <p className="mt-5 text-sm text-[#1f2329] leading-relaxed">&ldquo;{main.quote}&rdquo;</p>
              <div className="mt-auto pt-6 flex items-end gap-2">
                <span className="font-heading text-4xl font-extrabold bg-gradient-to-r from-[#2f51d6] to-[#7b5cff] bg-clip-text text-transparent">
                  {main.metric}
                </span>
                <span className="text-xs text-[#646a73] mb-1.5">{main.metricLabel}</span>
              </div>
            </ScrollReveal>

            {rest.map((s, i) => (
              <button
                key={s.company}
                type="button"
                onClick={() => setActive((active + i + 1) % count)}
                className="text-left rounded-2xl bg-[#f5f6fa] p-5 flex flex-col hover:bg-[#eef1ff] transition-colors cursor-pointer"
              >
                <span className={`w-10 h-10 rounded-full bg-gradient-to-br ${AVATAR[(active + i + 1) % 3]} text-white font-bold flex items-center justify-center`}>
                  {s.name.charAt(0)}
                </span>
                <div className="mt-3 font-heading font-bold text-sm text-[#1f2329]">{s.company}</div>
                <div className="text-[11px] text-[#8f959e]">
                  {s.name}, {s.role}
                </div>
                <div className="mt-auto pt-4 font-heading text-2xl font-extrabold text-[#1f2329]">{s.metric}</div>
                <div className="text-[11px] text-[#646a73]">{s.metricLabel}</div>
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
